const apiBase: string = '/api';
const commonBase: string = '/common';
const authBase: string = '/auth';
const userBase: string = '/users';
const ssoBase: string = '/sso';
const infosBase: string = '/infos';
const flashmeetingBase: string = '/fm';
const planiteamBase: string = '/fp';

export const API = {
  SIGN_IN: apiBase + commonBase + authBase + '/sign-in',
  SIGN_IN_SSO: apiBase + commonBase + authBase + '/sign-in-sso',
  IS_SIGN_IN: apiBase + commonBase + authBase + '/is-sign-in',
  SIGN_OUT: apiBase + commonBase + authBase + '/sign-out',
  SEND_PASSWORD_CODE: apiBase + commonBase + authBase + '/password/code/:email',
  INFOS_AUTH: apiBase + commonBase + infosBase + '/auth',
  VERIFY_PASSWORD_CODE: apiBase + commonBase + authBase + '/password/verify',
  SET_NEW_PASSWORD_CODE: apiBase + commonBase + authBase + '/password/new',
  GET_SSO: apiBase + commonBase + ssoBase + '/',
  USER_CHANGE_PASSWORD: apiBase + commonBase + userBase + '/{userId}/password',
  FLASHMEETING: apiBase + flashmeetingBase,
  PLANITEAM: apiBase + planiteamBase,
};